<template>
   <div class="mach-doch-einfach-page">
      <!-- Buraya istediğiniz içeriği ekleyebilirsiniz -->
      denemeler
   </div>
</template>

<script>
export default {
   name: "MachDochEinfachPage",
};
</script>

<style scoped>
.mach-doch-einfach-page {
   min-height: 100vh;
   background-color: white;
}
</style>
